
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

export interface TransactionSummaryItem {
    id: string;
    type: 'MINT' | 'SWAP' | 'LIQUIDITY' | 'BURN';
    user: string;
    description: string;
    amount?: string;
    tokenSymbol?: string;
    timestamp: number;
    chain: 'SOL' | 'SUI';
    status: 'SUCCESS' | 'PENDING' | 'FAILED';
    hash: string;
}

export const RECENT_ACTIVITY: TransactionSummaryItem[] = [
    {
        id: 'tx_1',
        type: 'MINT',
        user: '7xKX...9jL2',
        description: 'Minted 1B $NEURA',
        amount: '1,000,000,000',
        tokenSymbol: 'NEURA',
        timestamp: Date.now() - 120000,
        chain: 'SOL',
        status: 'SUCCESS',
        hash: '5x...'
    },
    {
        id: 'tx_2',
        type: 'SWAP',
        user: '0x82...3b1a',
        description: 'Bought 500 SUI of $SPEPE',
        amount: '500',
        tokenSymbol: 'SUI',
        timestamp: Date.now() - 350000,
        chain: 'SUI',
        status: 'SUCCESS',
        hash: '0x...'
    },
    {
        id: 'tx_3',
        type: 'LIQUIDITY',
        user: 'H8s...k2La',
        description: 'Locked 95% LP for $VOID',
        amount: '95%',
        tokenSymbol: 'VOID-LP',
        timestamp: Date.now() - 900000,
        chain: 'SOL',
        status: 'SUCCESS',
        hash: '3Y...'
    },
    {
        id: 'tx_4',
        type: 'MINT',
        user: 'Dez...263',
        description: 'Deployed $CYDOGE with 2% Tax',
        amount: '1,000,000,000',
        tokenSymbol: 'CYDOGE',
        timestamp: Date.now() - 1500000,
        chain: 'SOL',
        status: 'SUCCESS',
        hash: '9Z...'
    },
    {
        id: 'tx_5',
        type: 'SWAP',
        user: '9pL...m1K',
        description: 'Sold 1.5M $BONK for USDC',
        amount: '1,500,000',
        tokenSymbol: 'BONK',
        timestamp: Date.now() - 2100000,
        chain: 'SOL',
        status: 'SUCCESS',
        hash: '4A...'
    }
];
